import Logo from "@/assets/images/logoDark.svg";
import { AppPaths } from "@/shared/common/enums";
import { LanguageSelect } from "@/shared/components";
import { Image } from "@ab.uitools/ui-library/components/Image";
import { useNavigate } from "react-router-dom";

export const AuthHeader = () => {
  const navigate = useNavigate();
  return (
    <div id="auth-header-logo" className="auth-header">
      <div onClick={() => navigate(AppPaths.Login)}>
        <Image className="auth-header--logo cursor-pointer" imagePath={Logo}/>
      </div>
      <LanguageSelect/>
    </div>
  );
};
